namespace TabAurous.Production {
    export interface IssueMaterialDetailsRow {
        TransDetailId?: number;
        TransId?: number;
        TransDate?: string;
        PartyId?: number;
        VoucherTypeId?: number;
        DepartmentId?: number;
        ProductId?: number;
        ProductCode?: string;
        AttributeId?: number;
        Attribute?: string;
        BagNo?: string;
        SubBagNo?: number;
        SKU?: string;
        Line_No?: number;
        Pieces?: number;
        Weight?: number;
        RequiredPieces?: number;
        RequiredWeight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransDetailId?: number;
        ItemDetails?: IssueMaterialItemsRow[];
    }

    export namespace IssueMaterialDetailsRow {
        export const idProperty = 'TransDetailId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.IssueMaterialDetails';
        export const deletePermission = 'Production:IssueMaterial:Delete';
        export const insertPermission = 'Production:IssueMaterial:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:IssueMaterial:Edit';

        export declare const enum Fields {
            TransDetailId = "TransDetailId",
            TransId = "TransId",
            TransDate = "TransDate",
            PartyId = "PartyId",
            VoucherTypeId = "VoucherTypeId",
            DepartmentId = "DepartmentId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            BagNo = "BagNo",
            SubBagNo = "SubBagNo",
            SKU = "SKU",
            Line_No = "Line_No",
            Pieces = "Pieces",
            Weight = "Weight",
            RequiredPieces = "RequiredPieces",
            RequiredWeight = "RequiredWeight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransDetailId = "RefTransDetailId",
            ItemDetails = "ItemDetails"
        }
    }
}
